import React from 'react'

const Avatar = () => {
  return (
    <div>
      
    </div>
  )
}

export default Avatar
